import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-232ece32"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "role-table",
  id: "project-table"
}
const _hoisted_2 = { class: "operate" }
const _hoisted_3 = { class: "operate-search" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所在街道：", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "完成情况：", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "搜索：", -1))
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { class: "op" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

import {
  ref, unref, reactive, computed, watch, withDefaults, onMounted, onUnmounted,
} from 'vue';
import { useStore, } from 'vuex';
import {
  Input, Table, ConfigProvider, message, Select, Modal,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import moment, { Moment, } from 'moment';

import { ColumnProps, } from 'ant-design-vue/es/table/interface';
import CreateModal from './components/newModal/index.vue';
import ImportModal from './components/importModal/index.vue';

import {
  getStreetList,getCompletion,qryProjects,deleteProject,addOrUpdateProject,exportProjects,
} from './projectListReq';

type Key = ColumnProps['key'];

  type ColumnType = {
    title: string;
    align?: string,
    key?: string,
    dataIndex?: string;
    slots?: any;
    width?: any;
    ellipsis?: boolean;
  };
  type Params = {
    pageNum: number;
    pageSize: number;
    street?:string;
    completion?: string,
    searchParam?: string;
  };

  interface FormState {
    street: string | undefined;
    completion: string | undefined;
    searchParam: string | undefined;
  }

// 列表行配置

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { Option, } = Select;

const store = useStore();

  const columns: ColumnType[] = [
  {
    title: '序号',
    align: 'center',
    dataIndex: 'index',
    key: 'index',
    slots: { customRender: 'index', },
    width: '4%',
  },
  {
    title: '所在街道',
    dataIndex: 'street',
    key: 'street',
    width: '6%',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '企业名称',
    dataIndex: 'companyName',
    key: 'companyName',
    width: '16%',
    ellipsis: true,
  },
  {
    title: '项目编号',
    dataIndex: 'projectNumber',
    key: 'projectNumber',
    width: '8%',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '工程项目名称',
    dataIndex: 'projectName',
    key: 'projectName',
    width: '14%',
    ellipsis: true,
  },
  {
    title: '工程项目内容',
    dataIndex: 'projectContent',
    key: 'projectContent',
    width: '20%',
    ellipsis: true,
  },
  {
    title: '完成情况',
    dataIndex: 'completion',
    key: 'completion',
    width: '6%',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    width: '8%',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    width: '8%',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'op',
    slots: { customRender: 'op', },
    width: '10%',
  },
];
// 分页数据
const current = ref<number>(1);
const total = ref<number>(0);
// 选中的id
const selectedKeys = ref<any[]>([]);
// 选中的row
const selectedRow = ref<Key[]>([]);
// 列表数据
const punishList = computed(() => store.state.ticket.punishList);
// 街道列表
const streetList = ref<any[]>([]);
// 完成情况
const statusList = ref<any[]>([]);

// 表格数据
const tableData = ref<any>([]);
// 新建记录弹窗显隐
const modalVisible = ref<boolean>(false);
// 编辑记录显隐
const editVisible = ref<boolean>(false);
// 导入弹窗显隐
const importVisible = ref<boolean>(false);
// 单行信息
const itemInfo = ref<any>();

// 查询栏数据
const search = reactive<FormState>({
  street: '',
  completion: '',
  searchParam: '',
});
// 查询参数初始化
const initSearch = () => {
  search.street = '';
  search.completion = '';
  search.searchParam = '';
};

/**
 * 加载表格数据
 * @return {void}
 */
const loadSelectList = ():void => {
  getStreetList().then((res: any) => {
    if (res.code === '200' && res.data) {
      streetList.value = res.data;
    }
  });
  getCompletion().then((res: any) => {
    if (res.code === '200' && res.data) {
      statusList.value = res.data;
    }
  });
};

/**
 * 加载表格数据
 * @param {*} pageNum 当前页码
 * @return {void}
 */
const loadProjectTable = (pageNum = 1): void => {
  const {
    street,completion, searchParam,
  } = search;
  const params :Params =
    {
      pageNum,
      pageSize: 10,
    };

  params.street = street || '';
  params.completion = completion || '';
  params.searchParam = searchParam || '';

  qryProjects(params).then((result: any) => {
    if (result.code === '200' && result.data) {
      tableData.value = result.data.records;
      total.value = result.data.total;
      selectedKeys.value = [];
      selectedRow.value = [];
    }
  });
};

const handleSearch = ():void => {
  current.value = 1;
  loadProjectTable();
};
const handleReset = ():void => {
  initSearch();
};

const rowSelection = computed(() => ({
  selectedRowKeys: unref(selectedRow),
  onChange: (selectedRowKeys: Key[], selectedRows: any[]) => {
    selectedRow.value = selectedRowKeys;
    selectedKeys.value = [];
    // 获取选中的ids
    selectedRows.forEach((item: any) => {
      selectedKeys.value.push(item.id);
    });
  },
}));

const handleNew = (): void => {
  modalVisible.value = true;
};

/**
 * @method handleImport
 * @return {void} 批量导入
 */
const handleImport = (): void => {
  importVisible.value = true;
};

/**
 * @method handleOutPort
 * @return {void} 导出
 */
const handleExport = (): void => {
  // console.log('导出待完善');

  /*
   *const formData = new FormData();
   *if (selectedKeys.value.length) {
   *  selectedKeys.value.forEach((item) => {
   *    formData.append('idList', item);
   *  });
   *} else {
   *  formData.append('idList', '');
   *}
   * 调取接口下载
   *exportProjects(formData);
   */
};

const handleDelete = (id: any): void => {
  const params = {
    id,
  };

  deleteProject(params).then(() => {
    loadProjectTable(current.value);
  });
};

/**
 * @method handleEdit
 * @param {any} item 编辑的对象
 * @return {void}
 */
const handleEdit = (item: any): void => {
  itemInfo.value = item;
  modalVisible.value = true;
};

/**
 * @method handleChange
 * @param {any[]} page 传入当前点击的页码
 * @param {any[]} pageSize 传入当前点击的页数
 * @return {void}
 */
const handleChange = (page: any, pageSize: any) => {
  current.value = page;
  loadProjectTable(page);
};

const cancal = (str: string): void => {
  if (str === 'create') {
    modalVisible.value = false;
    itemInfo.value = [];
  } else if (str === 'edit') {
    editVisible.value = false;
  } else if (str === 'import') {
    importVisible.value = false;
  }
};

const save = (str: string): void => {
  if (str === 'create') {
    modalVisible.value = false;
  } else if (str === 'edit') {
    editVisible.value = false;
  } else if (str === 'import') {
    importVisible.value = false;
  }
  loadProjectTable(current.value);
};

onMounted(() => {
  // 加载表格数据
  loadProjectTable();
  // 加载选择框数据
  loadSelectList();
});

onUnmounted(() => {
  // store.commit('ticket/setStateItem',{ value: {},type: 'punishList', });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createVNode(_unref(Select), {
            value: _unref(search).street,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).street) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Option), {
                key: "-1",
                value: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(streetList.value, (val, idx) => {
                return (_openBlock(), _createBlock(_unref(Option), {
                  key: idx,
                  value: val
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(val), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createVNode(_unref(Select), {
            value: _unref(search).completion,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(search).completion) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Option), {
                key: "-1",
                value: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusList.value, (val, idx) => {
                return (_openBlock(), _createBlock(_unref(Option), {
                  key: idx,
                  value: val
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(val), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _createVNode(_unref(Input), {
            value: _unref(search).searchParam,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(search).searchParam) = $event)),
            placeholder: "可输入企业名称/项目编号/工程项目名称/项目工程内容"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", { class: "search-btns" }, [
          _createElementVNode("button", {
            class: "btn reset",
            onClick: handleReset
          }, "重置"),
          _createElementVNode("button", {
            class: "btn search",
            onClick: handleSearch
          }, "查询")
        ])
      ])
    ]),
    _createElementVNode("div", { class: "operate-button" }, [
      _createElementVNode("button", {
        class: "btn",
        onClick: handleNew
      }, "新建")
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
        default: _withCtx(() => [
          _createVNode(_unref(Table), {
            columns: columns,
            scroll: {
              y: '5.6rem'
            },
            pagination: {
              total:total.value,
              pageSize:10,
              size:'small',
              current:current.value,
              showQuickJumper: true,
              showTotal: (total) => `共 ${total} 条`,
              onChange: (page, pageSize) => handleChange(page, pageSize),
            },
            "data-source": tableData.value,
            "row-selection": _unref(rowSelection),
            bordered: ""
          }, {
            index: _withCtx(({ index,}) => [
              _createElementVNode("span", null, _toDisplayString(index + 1), 1)
            ]),
            completion: _withCtx(({ text,}) => [
              _createElementVNode("div", {
                class: _normalizeClass(`completion ${text === '已完成'?'':'red'}`)
              }, _toDisplayString(text), 3)
            ]),
            op: _withCtx(({ text, }) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleEdit(text))
                }, "编辑", 8, _hoisted_11),
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleDelete(text.id))
                }, "删除", 8, _hoisted_12)
              ])
            ]),
            _: 1
          }, 8, ["scroll", "pagination", "data-source", "row-selection"])
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _createVNode(CreateModal, {
      "create-visible": modalVisible.value,
      "item-info": itemInfo.value,
      "street-list": streetList.value,
      "status-list": statusList.value,
      onCancal: _cache[3] || (_cache[3] = ($event: any) => (cancal('create'))),
      onSave: _cache[4] || (_cache[4] = ($event: any) => (save('create')))
    }, null, 8, ["create-visible", "item-info", "street-list", "status-list"]),
    _createVNode(ImportModal, {
      "import-visible": importVisible.value,
      onCancal: _cache[5] || (_cache[5] = ($event: any) => (cancal('import'))),
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => (save('import')))
    }, null, 8, ["import-visible"])
  ]))
}
}

})